module.exports = {
      id: "symbol-link-out-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#symbol-link-out-usage",
      toString: function () {
        return this.url;
      }
    }